import React from 'react'
import { Footer, Navbar } from "../components";
const AboutPage = () => {
  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <h1 className="text-center">Acerca de nosotros</h1>
        <hr />
        <p className="lead text-center">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Nostrum
          facere doloremque veritatis odit similique sequi. Odit amet fuga nam
          quam quasi facilis sed doloremque saepe sint perspiciatis explicabo
          totam vero quas provident ipsam, veritatis nostrum velit quos
          recusandae est mollitia esse fugit dolore laudantium. Ex vel explicabo
          earum unde eligendi autem praesentium, doloremque distinctio nesciunt
          porro tempore quis eaque labore voluptatibus ea necessitatibus
          exercitationem tempora molestias. Ad consequuntur veniam sequi ullam
          tempore vel tenetur soluta dolore sunt maxime aliquam corporis est,
          quo saepe dolorem optio minus sint nemo totam dolorum! Reprehenderit
          delectus expedita a alias nam recusandae illo debitis repellat libero,
          quasi explicabo molestiae saepe, dolorem tempore itaque eveniet quam
          dignissimos blanditiis excepturi harum numquam vel nihil? Ipsum
        </p>

        <h2 className="text-center py-4">Nuestros productos</h2>
        <div className="row">
          <div className="col-md-3 col-sm-6 mb-3 px-3">
            <div className="card h-100">
              <img className="card-img-top img-fluid" src="https://firebasestorage.googleapis.com/v0/b/ecommerce-nemotec.appspot.com/o/HTB1J6yUexPI8KJjSspfq6ACFXXaC.jpg?alt=media&token=3992cf09-793c-4371-902b-259c68fb86f7&_gl=1*10gz2ki*_ga*NDUyODkzMTg0LjE2ODQ1Mjg1ODk.*_ga_CW55HF8NVT*MTY4NjExMTU3Mi4yMi4xLjE2ODYxMTE2NDEuMC4wLjA." alt="" height={160} />
              <div className="card-body">
                <h5 className="card-title text-center">Refacciónes</h5>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 mb-3 px-3">
            <div className="card h-100">
              <img className="card-img-top img-fluid" src="https://firebasestorage.googleapis.com/v0/b/ecommerce-nemotec.appspot.com/o/R%20(10).jpg?alt=media&token=4c29b840-23aa-4630-89a5-b5848c0c8e4c&_gl=1*1fvofsa*_ga*NDUyODkzMTg0LjE2ODQ1Mjg1ODk.*_ga_CW55HF8NVT*MTY4NjExMTU3Mi4yMi4xLjE2ODYxMTE2NzUuMC4wLjA." alt="" height={160} />
              <div className="card-body">
                <h5 className="card-title text-center">Lubricantes y Refrigerantes</h5>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 mb-3 px-3">
            <div className="card h-100">
              <img className="card-img-top img-fluid" src="https://firebasestorage.googleapis.com/v0/b/ecommerce-nemotec.appspot.com/o/R%20(9).jpg?alt=media&token=2023d7ae-4f25-4481-8767-eb16968fd56a&_gl=1*ozzzll*_ga*NDUyODkzMTg0LjE2ODQ1Mjg1ODk.*_ga_CW55HF8NVT*MTY4NjExMTU3Mi4yMi4xLjE2ODYxMTE2MTEuMC4wLjA." alt="" height={160} />
              <div className="card-body">
                <h5 className="card-title text-center">Llantas</h5>
              </div>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 mb-3 px-3">
            <div className="card h-100">
              <img className="card-img-top img-fluid" src="https://firebasestorage.googleapis.com/v0/b/ecommerce-nemotec.appspot.com/o/R%20(8).jpg?alt=media&token=64539dc8-da78-4d31-9fc1-bc372a082538&_gl=1*7zytji*_ga*NDUyODkzMTg0LjE2ODQ1Mjg1ODk.*_ga_CW55HF8NVT*MTY4NjExMTU3Mi4yMi4xLjE2ODYxMTE3MDkuMC4wLjA." alt="" height={160} />
              <div className="card-body">
                <h5 className="card-title text-center">Calaberas</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default AboutPage